import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
    Button,
    Card,
    Col,
    Container,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    Spinner,
} from "reactstrap";
import DeleteModal from "../../components/DeleteModal";
import {
    addStrategyRating,
    getAthleteMomentos,
    getMoreAthleteMomentos,
    momentoPrivatePurchase,
    updateMomentoStatus,
    updateRatingData,
} from "../../store/actions/MomentosActions";
import moment from "moment/moment";
import Paypal from "../../components/PaypalPayment";
import { toast } from "react-toastify";
import { Rating } from "@mui/material";
import firebase from "../../config/firebase";

const ManageMomentos = () => {
    const dispatch = useDispatch();
    const { uid, user } = useSelector((state) => state.authUser);
    const { myMomentos, loading } = useSelector((state) => state.momentos);
    const history = useHistory();
    const [modal, setModal] = useState(false);
    const [allowDetailsIndex, setAllowDetailsIndex] = useState(-1);
    const [ID, setID] = useState("");
    const [privateModal, setPrivateModal] = useState(false);
    const [publicModal, setPublicModal] = useState(false);
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreLoader, setLoadMoreLoader] = useState(false);
    const [privateObj, setPrivateObj] = useState({ id: "", private: false });
    const [docId, setDocId] = useState("");
    const [ratingModal, setRatingModal] = useState(false);
    const [selectedRating, setSelectedRating] = useState(0);
    const [selectedOption, setSelectedOption] = useState("");
    const [remarks, setRemarks] = useState("");
    const [strategyRating, setStrategyRating] = useState(false);
    const [selectedStrategyRating, setSelectedStrategyRating] = useState(0);
    const [strategyRemarks, setStrategyRemarks] = useState("");
    const [managerEmail, setManagerEmail] = useState("");
    const toggleRatingModal = () => {
        setRatingModal(!ratingModal);
        setStrategyRating(false);
        setSelectedStrategyRating(0);
        setStrategyRemarks("");
        setRemarks("");
        setSelectedRating("");
        setSelectedOption("");
    };
    const toggle = () => setModal(!modal);

    const [btnLoader, serButtonLoader] = useState(false);

    const handleRatingSubmit = () => {
        const ratingData = {
            rating: selectedRating,
            satisfactory: selectedOption,
            remarks: remarks,
            managerRating: true,
        };
        serButtonLoader(true);
        dispatch(
            updateRatingData(ratingData, docId, () => {
                if (strategyRating) {
                    dispatch(
                        addStrategyRating({
                            athleteName: user.first_name + " " + user.last_name,
                            athleteId: user.athleteID,
                            athleteEmail: user.email,
                            strategyRating: selectedStrategyRating,
                            strategyRemarks: strategyRemarks,
                            managerEmail: managerEmail,
                            docId: docId,
                            createdAt: firebase.firestore.Timestamp.now(),
                        })
                    );
                }
                toast.success("Add Rating Successfully");
                serButtonLoader(false);
                toggleRatingModal();
            })
        );
    };

    const formatDate = (date) => {
        const unixTimestamp = date.seconds + date.nanoseconds / 1e9;
        const jsDate = new Date(unixTimestamp * 1000);

        const formattedDate = moment(jsDate).format("DD/MM/YYYY HH:mm");
        return formattedDate;
    };

    useEffect(() => {
        dispatch(getAthleteMomentos(uid));
    }, []);
    const onPurchaseSuccess = (order) => {
        let payload = {
            amount: order?.purchase_units[0]?.amount,
            payment_id: order.id,
            athlete_id: uid,
            isPayout: false,
            isRefunded: false,
            momentoId: privateObj?.id,
            via: "paypal",
        };
        dispatch(
            momentoPrivatePurchase(payload, () => {
                dispatch(
                    updateMomentoStatus(
                        privateObj.id,
                        privateObj.private,
                        () => {
                            setPrivateObj({ id: "", private: false });
                            setPrivateModal(false);
                            toast.success("Memento Private Successfully");
                        }
                    )
                );
            })
        );
    };
    return (
        <Container fluid>
            <Row className="justify-content-center  mx-4 py-3">
                <h3>Manage Momentos</h3>
            </Row>
            {loading ? (
                <Row className="justify-content-center">
                    <Spinner size="sm" />
                </Row>
            ) : (
                <Container>
                    <Row className="justify-content-end my-3 mr-1">
                        <Button
                            onClick={() =>
                                history.push("/main/create-momentos/ ")
                            }
                            color="primary"
                            // disabled={!user?.momentoCount >= 3}
                        >
                            Create Mementos
                        </Button>
                    </Row>
                    {myMomentos?.map((item, index) => {
                        return (
                            <>
                                <Card
                                    className="mb-5 p-4 create_momento-card"
                                    key={item.id}
                                >
                                    <Row className="p-3 d-flex justify-content-center align-items-center">
                                        <Col lg={4} md={4} sm={10}>
                                            <div>
                                                <Label>Memento Title</Label>
                                                <p>
                                                    <strong>
                                                        {item?.momentoTitle}
                                                    </strong>
                                                </p>
                                            </div>
                                            <div>
                                                <Label>
                                                    Memento Description
                                                </Label>
                                                <p>
                                                    <strong>
                                                        {
                                                            item?.momentoDescription
                                                        }
                                                    </strong>
                                                </p>
                                            </div>
                                        </Col>
                                        <Col lg={4} md={4} sm={10}>
                                            <div>
                                                <Label>Athlete</Label>
                                                <p>
                                                    <strong>
                                                        {item?.athleteName}
                                                    </strong>
                                                </p>
                                            </div>
                                            <div>
                                                <Label>Created</Label>
                                                <p>
                                                    <strong>
                                                        {item?.createdAt &&
                                                            formatDate(
                                                                item?.createdAt
                                                            )}
                                                    </strong>
                                                </p>
                                            </div>
                                        </Col>
                                        <Col lg={4} md={4} sm={10}>
                                            <div>
                                                <Label>Memento ID</Label>
                                                <p>
                                                    <strong>
                                                        {" "}
                                                        {item?.momentoID}
                                                        {/* {item?.athleteID}-M00
                                                        {index + 1} */}
                                                    </strong>
                                                </p>
                                            </div>
                                            <div>
                                                <Label>Athlete ID</Label>
                                                <p>
                                                    <strong>
                                                        {item?.athleteID}
                                                    </strong>
                                                </p>
                                            </div>
                                        </Col>
                                    </Row>
                                    {allowDetailsIndex === index && (
                                        <Container className="d-flex flex-column momento__media">
                                            <Row className="p-3 flex-nowrap">
                                                <Col className="col-1 d-flex flex-column justify-content-around pt-5 mr-1 pl-0 momento__media-qrCode_col">
                                                    {item.qrCodes?.map(
                                                        (qrCode, qrIdx) => {
                                                            if (
                                                                qrIdx == 0 ||
                                                                qrIdx == 1
                                                            ) {
                                                                return (
                                                                    <>
                                                                        {qrCode !==
                                                                        "" ? (
                                                                            <div className="position-relative">
                                                                                <img
                                                                                    src={
                                                                                        qrCode instanceof
                                                                                        File
                                                                                            ? URL.createObjectURL(
                                                                                                  qrCode
                                                                                              )
                                                                                            : qrCode
                                                                                    }
                                                                                    className="w-100 create_momento-QR_img"
                                                                                    alt={`QR Code ${qrIdx}`}
                                                                                />
                                                                            </div>
                                                                        ) : (
                                                                            <div className="create_momento-qrcode_div d-flex justify-content-center align-items-center border-0"></div>
                                                                        )}
                                                                    </>
                                                                );
                                                            }
                                                        }
                                                    )}
                                                </Col>

                                                {item?.momento?.map(
                                                    (momentoItem) => {
                                                        return (
                                                            <Col className="p-2 momento__media-card">
                                                                <Card className="w-100 p-3 create_momento-card d-flex flex-column justify-content-start align-items-center">
                                                                    <p className="mt-3 text-capitalize">
                                                                        <strong>
                                                                            {
                                                                                momentoItem.title
                                                                            }
                                                                        </strong>
                                                                    </p>
                                                                    <p className="mt-3 text-capitalize">
                                                                        {
                                                                            momentoItem.subTitle
                                                                        }
                                                                    </p>

                                                                    <div className="create_momento__media-div">
                                                                        {momentoItem?.media ? (
                                                                            <img
                                                                                src={
                                                                                    momentoItem.media
                                                                                }
                                                                                alt="img"
                                                                                className="w-100 create_momento__media-div_img"
                                                                            />
                                                                        ) : (
                                                                            <>
                                                                                No
                                                                                Media
                                                                                Attached
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </Card>
                                                            </Col>
                                                        );
                                                    }
                                                )}
                                                <Col className="col-1 d-flex flex-column-reverse justify-content-around pt-5 mr-1 pr-0 momento__media-qrCode_col">
                                                    {item.qrCodes?.map(
                                                        (qrCode, qrIdx) => {
                                                            if (
                                                                qrIdx ===
                                                                    item.qrCodes
                                                                        .length -
                                                                        2 ||
                                                                qrIdx ===
                                                                    item.qrCodes
                                                                        .length -
                                                                        1
                                                            ) {
                                                                return (
                                                                    <>
                                                                        {qrCode !==
                                                                        "" ? (
                                                                            <div className="position-relative">
                                                                                <img
                                                                                    src={
                                                                                        qrCode instanceof
                                                                                        File
                                                                                            ? URL.createObjectURL(
                                                                                                  qrCode
                                                                                              )
                                                                                            : qrCode
                                                                                    }
                                                                                    className="w-100 create_momento-QR_img"
                                                                                    alt={`QR Code ${qrIdx}`}
                                                                                />
                                                                            </div>
                                                                        ) : (
                                                                            <div className="create_momento-qrcode_div d-flex justify-content-center align-items-center border-0"></div>
                                                                        )}
                                                                    </>
                                                                );
                                                            }
                                                        }
                                                    )}
                                                </Col>
                                            </Row>
                                            <Row className="d-flex justify-content-between align-items-center mx-0 px-0 my-3 flex-nowrap">
                                                {item.qrCodes?.map(
                                                    (qrCode, qrIdx) => {
                                                        if (
                                                            qrIdx >= 2 &&
                                                            qrIdx <
                                                                item.qrCodes
                                                                    .length -
                                                                    2
                                                        ) {
                                                            return (
                                                                <div className="momento__media-qrCode_row">
                                                                    {qrCode !==
                                                                    "" ? (
                                                                        <div className="position-relative">
                                                                            <img
                                                                                src={
                                                                                    qrCode instanceof
                                                                                    File
                                                                                        ? URL.createObjectURL(
                                                                                              qrCode
                                                                                          )
                                                                                        : qrCode
                                                                                }
                                                                                className="w-100 create_momento-QR_img"
                                                                                alt={`QR Code ${qrIdx}`}
                                                                            />
                                                                        </div>
                                                                    ) : (
                                                                        <div className="create_momento-qrcode_div d-flex justify-content-center align-items-center border-0"></div>
                                                                    )}
                                                                </div>
                                                            );
                                                        }
                                                    }
                                                )}
                                            </Row>
                                        </Container>
                                    )}

                                    <Row className=" my-3 justify-content-center justify-content-md-end pr-md-4">
                                        <Button
                                            size="sm"
                                            color="primary"
                                            className="mx-2"
                                            onClick={() => {
                                                if (
                                                    allowDetailsIndex == index
                                                ) {
                                                    setAllowDetailsIndex(-1);
                                                } else {
                                                    setAllowDetailsIndex(index);
                                                }
                                            }}
                                        >
                                            {allowDetailsIndex == index
                                                ? "Hide"
                                                : "View"}{" "}
                                            Details
                                        </Button>
                                        {item?.private ? (
                                            <Button
                                                size="sm"
                                                color="success"
                                                onClick={() => {
                                                    setPublicModal(
                                                        !publicModal
                                                    );
                                                    setPrivateObj({
                                                        id: item.id,
                                                        private: !item.private,
                                                    });
                                                }}
                                            >
                                                Make it Public
                                            </Button>
                                        ) : (
                                            <Button
                                                size="sm"
                                                color="primary"
                                                onClick={() => {
                                                    setPrivateModal(
                                                        !privateModal
                                                    );
                                                    setPrivateObj({
                                                        id: item.id,
                                                        private: !item.private,
                                                    });
                                                }}
                                            >
                                                Make it Private
                                            </Button>
                                        )}

                                        <Button
                                            size="sm"
                                            color="info"
                                            className="mx-2"
                                            onClick={() =>
                                                history.push(
                                                    `/main/edit-momento/${item?.id}`
                                                )
                                            }
                                        >
                                            Edit Memento
                                        </Button>
                                        {item.managerEmail ? (
                                            <Button
                                                size="sm"
                                                color="success"
                                                className="mx-2"
                                                disabled={item.managerRating}
                                                onClick={() => {
                                                    toggleRatingModal();
                                                    setDocId(item.id);
                                                    setManagerEmail(
                                                        item.managerEmail
                                                    );
                                                }}
                                            >
                                                Manager Rating
                                            </Button>
                                        ) : (
                                            ""
                                        )}
                                        <Button
                                            size="sm"
                                            color="danger"
                                            className="mr-2"
                                            onClick={() => {
                                                toggle();
                                                setID(item?.id);
                                            }}
                                        >
                                            Delete Memento
                                        </Button>
                                    </Row>
                                </Card>
                            </>
                        );
                    })}
                    <Row className="float-right mt-2 mb-4 mr-3">
                        {myMomentos.length > 4 && (
                            <Button
                                color="primary"
                                size="sm"
                                disabled={loadMore}
                                onClick={() => {
                                    setLoadMoreLoader(true);
                                    dispatch(
                                        getMoreAthleteMomentos(
                                            uid,
                                            myMomentos[myMomentos.length - 1],
                                            () => {
                                                setLoadMore(true);
                                                setLoadMoreLoader(false);
                                            },
                                            () => {
                                                setLoadMoreLoader(false);
                                            }
                                        )
                                    );
                                }}
                            >
                                {loadMoreLoader ? (
                                    <Spinner size="sm" />
                                ) : (
                                    "Load More"
                                )}
                            </Button>
                        )}
                    </Row>
                </Container>
            )}
            <Modal isOpen={privateModal} toggle={() => setPrivateModal(false)}>
                <ModalHeader toggle={() => setPrivateModal(false)}>
                    Make Memento Private
                </ModalHeader>
                <ModalBody>Making Memento Private will cost you $10</ModalBody>
                <ModalFooter>
                    <Paypal
                        amount={10 + 0.5}
                        onPurchaseSuccess={onPurchaseSuccess}
                    />
                </ModalFooter>
            </Modal>
            <Modal isOpen={publicModal} toggle={() => setPublicModal(false)}>
                <ModalHeader toggle={() => setPublicModal(false)}>
                    Make Memento Public
                </ModalHeader>
                <ModalBody>
                    <span className="text-danger">Note: </span>Making Memento
                    Public, You will have to pay $10 again if you want to make
                    the same memento private, Do you still want to proceed?
                </ModalBody>
                <ModalFooter>
                    <Button
                        size="sm"
                        color="danger"
                        onClick={() =>
                            dispatch(
                                updateMomentoStatus(
                                    privateObj.id,
                                    privateObj.private,
                                    () => {
                                        setPrivateObj({
                                            id: "",
                                            private: false,
                                        });
                                        setPublicModal(false);
                                        toast.success(
                                            "Memento Public Successfully"
                                        );
                                    }
                                )
                            )
                        }
                    >
                        Done
                    </Button>
                    <Button
                        size="sm"
                        color="primary"
                        onClick={() => setPublicModal(false)}
                    >
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>

            <DeleteModal modal={modal} toggle={toggle} ID={ID} uid={uid} />
            <Modal isOpen={ratingModal} toggle={toggleRatingModal} centered>
                <Container className="text-center p-5">
                    <h4 className="mb-4">Rate this Badge</h4>
                    <Row className="justify-content-center">
                        <Rating
                            value={selectedRating}
                            onChange={(event, newValue) => {
                                setSelectedRating(newValue);
                            }}
                            stars={3}
                        />
                    </Row>
                    <Row>
                        <FormGroup>
                            <Label for="radioButtons">Choose an option:</Label>
                            <div>
                                <Col lg="4">
                                    <Label check>
                                        <Input
                                            type="radio"
                                            name="radioOptions"
                                            value="Satisfied"
                                            checked={
                                                selectedOption === "Satisfied"
                                            }
                                            onChange={(e) =>
                                                setSelectedOption(
                                                    e.target.value
                                                )
                                            }
                                        />
                                        Satisfied
                                    </Label>
                                </Col>
                                <Col lg="4">
                                    <Label check>
                                        <Input
                                            type="radio"
                                            name="radioOptions"
                                            value="Unsatisfied"
                                            checked={
                                                selectedOption === "Unsatisfied"
                                            }
                                            onChange={(e) =>
                                                setSelectedOption(
                                                    e.target.value
                                                )
                                            }
                                        />
                                        Unsatisfied
                                    </Label>
                                </Col>
                            </div>
                        </FormGroup>
                    </Row>
                    <FormGroup>
                        <Label for="remarks">Remarks</Label>
                        <Input
                            type="textarea"
                            name="remarks"
                            id="remarks"
                            value={remarks}
                            onChange={(e) => setRemarks(e.target.value)}
                        />
                    </FormGroup>
                    <Row className="mt-0 mb-3">
                        <Col>
                            <Label>You want to give strategy Rating:</Label>
                        </Col>
                        <Col>
                            <div>
                                <p className="edit-password-info">
                                    <div className="switchBtnContainer">
                                        <div
                                            className="switchBtn"
                                            style={{
                                                backgroundColor: strategyRating
                                                    ? "#4caf50"
                                                    : "#f44336",
                                            }}
                                            onClick={() =>
                                                setStrategyRating(
                                                    !strategyRating
                                                )
                                            }
                                        >
                                            <div
                                                className="switchBtnSlider"
                                                style={{
                                                    left: strategyRating
                                                        ? "26px"
                                                        : "2px",
                                                }}
                                            ></div>
                                        </div>
                                        <span className="switchBtnLabel">
                                            {strategyRating ? "Yes" : "No"}
                                        </span>
                                    </div>
                                </p>
                            </div>
                        </Col>
                    </Row>
                    {strategyRating && (
                        <>
                            <h4 className="mb-4">
                                Strategy Rating For Manager
                            </h4>
                            <Row className="justify-content-center">
                                <Rating
                                    value={selectedStrategyRating}
                                    onChange={(event, newValue) => {
                                        setSelectedStrategyRating(newValue);
                                    }}
                                    stars={3}
                                />
                            </Row>
                            <FormGroup>
                                <Label for="strategy-remarks">
                                    Strategy Remarks
                                </Label>
                                <Input
                                    required
                                    type="textarea"
                                    name="strategy-remarks"
                                    id="strategy-remarks"
                                    value={strategyRemarks}
                                    onChange={(e) =>
                                        setStrategyRemarks(e.target.value)
                                    }
                                />
                            </FormGroup>
                        </>
                    )}
                    <Button
                        color="primary"
                        onClick={handleRatingSubmit}
                        disabled={btnLoader}
                    >
                        {btnLoader ? <Spinner size="sm" /> : "Submit Rating"}
                    </Button>
                    <Button
                        color="secondary"
                        className="mx-2"
                        onClick={toggleRatingModal}
                    >
                        Cancel
                    </Button>
                </Container>
            </Modal>
        </Container>
    );
};

export default ManageMomentos;
